// extracted by mini-css-extract-plugin
export var content = "ForgotPasswordForm-module__content___CBa5n";
export var error = "ForgotPasswordForm-module__error___Vsb0m";
export var heading = "ForgotPasswordForm-module__heading___KZPWh";